import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=61678308&"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VListGroup,VListItemTitle})
